import React, { useState } from "react";
import Website from "../images/web-dev.png";
import Application from "../images/mob-dev.png";
import Market from "../images/marketing.png";
import Graphics from "../images/graphics.png";
import UI from "../images/ui-ux.png";
import Production from "../images/production.png";
import ScrollTrigger from "react-scroll-trigger";
import { AiOutlineArrowRight } from "react-icons/ai";
import { AiOutlineCheckSquare } from "react-icons/ai";
import { RxCross2 } from "react-icons/rx";

const Services = () => {
  const [animationOn, setAnimationOn] = useState(false);

  const [web, setWeb] = useState(false); 
  const [app, setApp] = useState(false); 
  const [ui, setUi] = useState(false);
  const [digital, setDigital] = useState(false);
  const [graphic, setGraphic] = useState(false);
  const [content, setContent] = useState(false);

  return (
    <>
      {web && (
        <div className="modalweb">
          <div className="modalContent">
            <RxCross2 className="modalClose" onClick={() => setWeb(false)} />
            <h2>WEBSITE DEVELOPMENT</h2>
            <p className="modalMainPara">
              Crafting web solutions that captivate, perform, and drive success for your brand.
            </p>
            <div className="modalServices">
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Custom Websites Tailored sites for unique brands.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Scalable, responsive, powerful web applications.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Secure, seamless online shopping solutions.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Easy content management and updates.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">Responsive designs for all devices.</p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">Ongoing website care.</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {app && (
        <div className="modalweb">
          <div className="modalContent">
            <RxCross2 className="modalClose" onClick={() => setApp(false)} />
            <h2>APPLICATION DEVELOPMENT</h2>
            <p className="modalMainPara">
              Turning ideas into powerful, user-friendly apps for success in the digital world.
            </p>
            <div className="modalServices">
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Tailored solutions for unique needs.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Scalable, responsive, powerful mobile applications.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Secure, seamless online application solutions.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Intuitive, user-friendly app interfaces.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Apps for various devices and platforms.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">Ongoing app care and enhancements.</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {ui && (
        <div className="modalweb">
          <div className="modalContent">
            <RxCross2 className="modalClose" onClick={() => setUi(false)} />
            <h2>UI / UX DESIGN</h2>
            <p className="modalMainPara">
            Creating immersive, user-centric interfaces for memorable digital experiences.
            </p>
            <div className="modalServices">
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  User-centered, intuitive experiences for applications.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Unique, visually engaging user interface design.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Designs that adapt to various devices.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Thorough testing for optimal user experiences.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Crafting compelling brand visuals and aesthetics.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Rapid concept testing and refinement.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {digital && (
        <div className="modalweb">
          <div className="modalContent">
            <RxCross2
              className="modalClose"
              onClick={() => setDigital(false)}
            />
            <h2>DIGITAL MARKETING</h2>
            <p className="modalMainPara">
            Unlock online potential with data-driven strategies, engaging content, and targeted campaigns.
            </p>
            <div className="modalServices">
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Boost online visibility with SEO techniques.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Engage, grow, and influence online communities.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Effective pay-per-click campaigns for conversions.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  High-quality content to drive audience engagement.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Targeted email marketing for customer engagement.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Data-driven insights for continual improvement.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {graphic && (
        <div className="modalweb">
          <div className="modalContent">
            <RxCross2
              className="modalClose"
              onClick={() => setGraphic(false)}
            />
            <h2>GRAPHICS DESIGN</h2>
            <p className="modalMainPara">
            Elevate your brand with stunning visuals and captivating design solutions.
            </p>
            <div className="modalServices">
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Unique, captivating visuals tailored to brands.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">Creating memorable brand Logos.</p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">Stunning designs for all media.</p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Unique and expressive digital illustrations.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Data-driven visual content for effective communication.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Layout and design for printed materials.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {content && (
        <div className="modalweb">
          <div className="modalContent">
            <RxCross2
              className="modalClose"
              onClick={() => setContent(false)}
            />
            <h2>CONTENT PRODUCTION</h2>
            <p className="modalMainPara">
              Crafting compelling content across various media platforms, telling your unique story.
            </p>
            <div className="modalServices">
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Crafted content to captivate your audience.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Visual storytelling for brand engagement.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Informative, engaging written content creation.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Audio content for a dynamic audience.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Stunning visual content for storytelling.
                </p>
              </div>
              <div className="modalService">
                <AiOutlineCheckSquare className="modalIcon" />
                <p className="modalPara">
                  Quality assurance for written materials.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="services" id="services">
        <h1 className="mainHeading">Services</h1>
        <p className="mainPara">What i Offer</p>

        <ScrollTrigger
          onEnter={() => setAnimationOn(true)}
          onExit={() => setAnimationOn(false)}
        >
          {animationOn && (
            <div className="servicesContent animate__animated animate__fadeInRight">
              <div className="service">
                <img src={Website} alt="" />
                <h4>Website Development</h4>
                <button
                  type="button"
                  className="hiddenBtn"
                  onClick={() => setWeb(true)}
                >
                  <p>
                    View more
                    <AiOutlineArrowRight
                      style={{ marginLeft: "2px" }}
                      className="proIcon"
                    />
                  </p>
                </button>
              </div>
              <div className="service">
                <img src={Application} alt="" />
                <h4>Application Development</h4>
                <button
                  type="button"
                  onClick={() => setApp(true)}
                  className="hiddenBtn"
                >
                  <p>
                    View more
                    <AiOutlineArrowRight
                      style={{ marginLeft: "2px" }}
                      className="proIcon"
                    />
                  </p>
                </button>
              </div>
              <div className="service">
                <img src={UI} alt="" />
                <h4>UI / UX Design</h4>
                <button
                  type="button"
                  onClick={() => setUi(true)}
                  className="hiddenBtn"
                >
                  <p>
                    View more
                    <AiOutlineArrowRight
                      style={{ marginLeft: "2px" }}
                      className="proIcon"
                    />
                  </p>
                </button>
              </div>
              <div className="service">
                <img src={Market} alt="" />
                <h4>Digital Marketing</h4>
                <button
                  type="button"
                  onClick={() => setDigital(true)}
                  className="hiddenBtn"
                >
                  <p>
                    View more
                    <AiOutlineArrowRight
                      style={{ marginLeft: "2px" }}
                      className="proIcon"
                    />
                  </p>
                </button>
              </div>
              <div className="service">
                <img src={Graphics} alt="" />
                <h4>Graphics Design</h4>
                <button
                  type="button"
                  onClick={() => setGraphic(true)}
                  className="hiddenBtn"
                >
                  <p>
                    View more
                    <AiOutlineArrowRight
                      style={{ marginLeft: "2px" }}
                      className="proIcon"
                    />
                  </p>
                </button>
              </div>
              <div className="service">
                <img src={Production} alt="" />
                <h4>Content Production</h4>
                <button
                  type="button"
                  onClick={() => setContent(true)}
                  className="hiddenBtn"
                >
                  <p>
                    View more
                    <AiOutlineArrowRight
                      style={{ marginLeft: "2px" }}
                      className="proIcon"
                    />
                  </p>
                </button>
              </div>
            </div>
          )}
        </ScrollTrigger>
      </div>
    </>
  );
};

export default Services;
